<div class="profile">
  <div class="about">
    <div class="profilePreview">
      <div class="userIcon">
        <div class="cover">
          <img src="assets/user.jpg" alt="" />
          <!-- <div class="empty">T</div> -->
        </div>
        <div class="info">
          <div class="name">John wick</div>
          <div class="tagline">Chef</div>
        </div>
      </div>
    </div>
    <div class="description">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper
      nunc ut metus auctor ultrices. Fusce commodo, orci eget lacinia congue,
      lorem metus pretium metus, sed posuere felis massa quis enim. Interdum et
      malesuada fames ac ante ipsum primis in faucibus. Nulla felis sapien,
      porttitor faucibus sapie
    </div>
    <div class="action">
      <button>Edit profile</button>
    </div>
    <div class="showcase">
      <div>
        <img src="assets/award-symbol-left.png" alt="" />
        <div>
          <div class="icon">
            <ion-icon name="restaurant-outline"></ion-icon>
          </div>
          <div class="count">122</div>
          <div class="label">Recipes</div>
        </div>
        <img src="assets/award-symbol-right.png" alt="" />
      </div>
      <div>
        <img src="assets/award-symbol-left.png" alt="" />
        <div>
          <div class="icon"><ion-icon name="heart-outline"></ion-icon></div>
          <div class="count">564</div>
          <div class="label">Likes</div>
        </div>
        <img src="assets/award-symbol-right.png" alt="" />
      </div>
      <div>
        <img src="assets/award-symbol-left.png" alt="" />
        <div>
          <div class="icon"><ion-icon name="star-outline"></ion-icon></div>
          <div class="count">2327</div>
          <div class="label">Ratings</div>
        </div>
        <img src="assets/award-symbol-right.png" alt="" />
      </div>
    </div>
  </div>
  <div class="section">
    <div class="title">My recipes</div>
    <div class="content">
      <button routerLink="/111/aaa" class="recipeCard">
        <div class="cover">
          <img src="assets/categories/burger.jpg" alt="" />
        </div>

        <div class="wrapper">
          <div class="info">
            <div class="name">Baked Chicken Burgers Recipe</div>
            <div class="calories">25 calories</div>
          </div>
          <div class="meta">
            <div>
              <div>Time</div>
              <div>25 mins</div>
            </div>
            <div>
              <div>Portion</div>
              <div>5 persons</div>
            </div>
          </div>
          <div class="counts">
            <div class="likes">
              <ion-icon name="heart-outline"></ion-icon> 92
            </div>
            <div class="chat">
              <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
            </div>
            <div class="ratings">
              <ion-icon name="star-outline"></ion-icon> 203
            </div>
          </div>
          <div class="option">
            <button class="edit">Edit</button>
            <button class="delete">Delete</button>
          </div>
        </div>
      </button>
      <button routerLink="/111/aaa" class="recipeCard">
        <div class="cover">
          <img src="assets/categories/fried_rice.jpg" alt="" />
        </div>
        <div class="wrapper">
          <div class="info">
            <div class="name">Unique Chicken Biryani Recipe</div>
            <div class="calories">42 calories</div>
          </div>
          <div class="meta">
            <div>
              <div>Time</div>
              <div>55 mins</div>
            </div>
            <div>
              <div>Portion</div>
              <div>2 persons</div>
            </div>
          </div>
          <div class="counts">
            <div class="likes">
              <ion-icon name="heart-outline"></ion-icon> 92
            </div>
            <div class="chat">
              <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
            </div>
            <div class="ratings">
              <ion-icon name="star-outline"></ion-icon> 203
            </div>
          </div>
          <div class="option">
            <button class="edit">Edit</button>
            <button class="delete">Delete</button>
          </div>
        </div>
      </button>
    </div>
  </div>
  <div class="section">
    <div class="title">Bookmarks</div>
    <div class="content">
      <button routerLink="/111/aaa" class="recipeCard">
        <div class="cover">
          <img src="assets/categories/pizza.jpg" alt="" />
        </div>
        <button class="bookmark active">
          <ion-icon name="bookmark"></ion-icon>
        </button>
        <div class="wrapper">
          <div class="info">
            <div class="name">Cheese Pizza</div>
            <div class="calories">14 calories</div>
          </div>
          <div class="meta">
            <div>
              <div>Time</div>
              <div>45 mins</div>
            </div>
            <div>
              <div>Portion</div>
              <div>3 persons</div>
            </div>
          </div>
          <div class="counts">
            <div class="likes">
              <ion-icon name="heart-outline"></ion-icon> 92
            </div>
            <div class="chat">
              <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
            </div>
            <div class="ratings">
              <ion-icon name="star-outline"></ion-icon> 203
            </div>
          </div>
        </div>
      </button>
      <button routerLink="/111/aaa" class="recipeCard">
        <div class="cover">
          <img src="assets/categories/juice.jpg" alt="" />
        </div>
        <button class="bookmark active">
          <ion-icon name="bookmark"></ion-icon>
        </button>
        <div class="wrapper">
          <div class="info">
            <div class="name">New York Cheesecake Recipe</div>
            <div class="calories">33 calories</div>
          </div>
          <div class="meta">
            <div>
              <div>Time</div>
              <div>32 mins</div>
            </div>
            <div>
              <div>Portion</div>
              <div>1 persons</div>
            </div>
          </div>
          <div class="counts">
            <div class="likes">
              <ion-icon name="heart-outline"></ion-icon> 92
            </div>
            <div class="chat">
              <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
            </div>
            <div class="ratings">
              <ion-icon name="star-outline"></ion-icon> 203
            </div>
          </div>
        </div>
      </button>
      <button routerLink="/111/aaa" class="recipeCard">
        <div class="cover">
          <img src="assets/categories/burger.jpg" alt="" />
        </div>
        <button class="bookmark active">
          <ion-icon name="bookmark"></ion-icon>
        </button>
        <div class="wrapper">
          <div class="info">
            <div class="name">Baked Chicken Burgers Recipe</div>
            <div class="calories">25 calories</div>
          </div>
          <div class="meta">
            <div>
              <div>Time</div>
              <div>25 mins</div>
            </div>
            <div>
              <div>Portion</div>
              <div>5 persons</div>
            </div>
          </div>
          <div class="counts">
            <div class="likes">
              <ion-icon name="heart-outline"></ion-icon> 92
            </div>
            <div class="chat">
              <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
            </div>
            <div class="ratings">
              <ion-icon name="star-outline"></ion-icon> 203
            </div>
          </div>
        </div>
      </button>
      <button routerLink="/111/aaa" class="recipeCard">
        <div class="cover">
          <img src="assets/categories/fried_rice.jpg" alt="" />
        </div>
        <button class="bookmark active">
          <ion-icon name="bookmark"></ion-icon>
        </button>
        <div class="wrapper">
          <div class="info">
            <div class="name">Unique Chicken Biryani Recipe</div>
            <div class="calories">42 calories</div>
          </div>
          <div class="meta">
            <div>
              <div>Time</div>
              <div>55 mins</div>
            </div>
            <div>
              <div>Portion</div>
              <div>2 persons</div>
            </div>
          </div>
          <div class="counts">
            <div class="likes">
              <ion-icon name="heart-outline"></ion-icon> 92
            </div>
            <div class="chat">
              <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
            </div>
            <div class="ratings">
              <ion-icon name="star-outline"></ion-icon> 203
            </div>
          </div>
        </div>
      </button>
      <button routerLink="/111/aaa" class="recipeCard">
        <div class="cover">
          <img src="assets/categories/pizza.jpg" alt="" />
        </div>
        <button class="bookmark active">
          <ion-icon name="bookmark"></ion-icon>
        </button>
        <div class="wrapper">
          <div class="info">
            <div class="name">Cheese Pizza</div>
            <div class="calories">14 calories</div>
          </div>
          <div class="meta">
            <div>
              <div>Time</div>
              <div>45 mins</div>
            </div>
            <div>
              <div>Portion</div>
              <div>3 persons</div>
            </div>
          </div>
          <div class="counts">
            <div class="likes">
              <ion-icon name="heart-outline"></ion-icon> 92
            </div>
            <div class="chat">
              <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
            </div>
            <div class="ratings">
              <ion-icon name="star-outline"></ion-icon> 203
            </div>
          </div>
        </div>
      </button>
      <button routerLink="/111/aaa" class="recipeCard">
        <div class="cover">
          <img src="assets/categories/juice.jpg" alt="" />
        </div>
        <button class="bookmark active">
          <ion-icon name="bookmark"></ion-icon>
        </button>
        <div class="wrapper">
          <div class="info">
            <div class="name">New York Cheesecake Recipe</div>
            <div class="calories">33 calories</div>
          </div>
          <div class="meta">
            <div>
              <div>Time</div>
              <div>32 mins</div>
            </div>
            <div>
              <div>Portion</div>
              <div>1 persons</div>
            </div>
          </div>
          <div class="counts">
            <div class="likes">
              <ion-icon name="heart-outline"></ion-icon> 92
            </div>
            <div class="chat">
              <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
            </div>
            <div class="ratings">
              <ion-icon name="star-outline"></ion-icon> 203
            </div>
          </div>
        </div>
      </button>
    </div>
  </div>
</div>
